import { subnavSwiper } from "./swiper";

let running = false;

document.addEventListener("click", (e) => {
    if (e.target.classList.contains("scroll-link")) {
        e.preventDefault();
        const id = e.target.getAttribute("href").replace("#", "");
        const parentEl = e.target.parentElement;
        const index = [...parentEl.parentElement.children].indexOf(parentEl);
        subnavSwiper.slideTo(index, 1000);
        const currentActive = document.querySelectorAll(".sub-nav .active");
        for (let i = currentActive.length - 1; i >= 0; i--) {
            currentActive[i].classList.remove("active");
        }
        e.target.classList.add("active");
        running = true;
        
        setTimeout(() => {
          scrollToAnchor(id);
          if (document.querySelector('.sub-nav .expanded')) {
            document.querySelector('button.subnav-button').click();
          }
      }, 50);
        setTimeout(() => {
            running = false;
        }, 1000);
        const menu = document.querySelector(".mobile-menu");
        menu.style.height = "";
        document.body.classList.remove("menu-open");
    }
});

function scrollToAnchor(id) {
    location.hash = "#" + id;
}

const spyScrolling = () => {
    const sections = document.querySelectorAll("section.spynav");
    const subNav = document.querySelector(".sub-nav");

    let index = 0;
    let oldIndex = index;

    window.onscroll = () => {
        if (running) return false;

        const scrollPos =
            document.documentElement.scrollTop || document.body.scrollTop;

        for (let s in sections)
            if (
                sections.hasOwnProperty(s) &&
                sections[s].offsetTop <= scrollPos + 160
            ) {
                const id = sections[s].id;
                const activeEl = subNav.querySelector('[href="#' + id + '"]');

                const currentActive = document.querySelectorAll(
                    ".sub-nav .active"
                );
                for (let i = currentActive.length - 1; i >= 0; i--) {
                    currentActive[i].classList.remove("active");
                }
                activeEl.classList.add("active");

                const parentEl = activeEl.parentElement;
                index = [...parentEl.parentElement.children].indexOf(parentEl);
            }
        if (oldIndex != index) {
            subnavSwiper.slideTo(index, 1000);
            oldIndex = index;
        }
    };
};

spyScrolling();
